<ng-container *ngIf="standalone; else notStandalone">
  <div class="share-ribbon-wrapper">
    <div class="share-title-wrapper">
      <img src="assets/images/new_social_media_icons/share.svg" alt="Megisztás" class="share-icon" />
      <span class="share-title">Oszd meg!</span>
    </div>
    <div class="icon-container">
      <img
        alt="Facebook"
        title="Facebook"
        class="social-media-icon"
        (click)="shareToFacebook()"
        src="../../../../assets/images/new_social_media_icons/facebook_icon.svg"
      />
      <img
        alt="Messenger"
        title="Messenger"
        class="social-media-icon"
        (click)="shareToMessenger()"
        src="../../../../assets/images/new_social_media_icons/messenger_icon.svg"
      />
      <img
        alt="Viber"
        title="Viber"
        class="social-media-icon"
        (click)="shareToViber()"
        src="../../../../assets/images/new_social_media_icons/viber_icon.svg"
      />
      <img
        alt="Whatsapp"
        title="Whatsapp"
        class="social-media-icon"
        (click)="shareToWhatsapp()"
        src="../../../../assets/images/new_social_media_icons/whatsapp_icon.svg"
      />
      <img
        alt="Telegram"
        title="Telegram"
        class="social-media-icon"
        (click)="shareToTelegram()"
        src="../../../../assets/images/new_social_media_icons/telegram_icon.svg"
      />
    </div>
  </div>
</ng-container>

<ng-template #notStandalone>
  <div class="share-ribbon-wrapper pointer" (click)="openShareDialog()">
    <div class="share-title-wrapper">
      <img src="assets/images/new_social_media_icons/share.svg" alt="Megisztás" class="share-icon" />
      <span class="share-title">Oszd meg!</span>
    </div>
    <div class="icon-container">
      <img
        alt="Facebook"
        title="Facebook"
        class="social-media-icon"
        src="../../../../assets/images/new_social_media_icons/facebook_icon.svg"
      />
      <img
        alt="Messenger"
        title="Messenger"
        class="social-media-icon"
        src="../../../../assets/images/new_social_media_icons/messenger_icon.svg"
      />
      <img
        alt="Viber"
        title="Viber"
        class="social-media-icon"
        src="../../../../assets/images/new_social_media_icons/viber_icon.svg"
      />
      <img
        alt="Whatsapp"
        title="Whatsapp"
        class="social-media-icon"
        src="../../../../assets/images/new_social_media_icons/whatsapp_icon.svg"
      />
      <img
        alt="Telegram"
        title="Telegram"
        class="social-media-icon"
        src="../../../../assets/images/new_social_media_icons/telegram_icon.svg"
      />
    </div>
  </div>
</ng-template>

<ose-share-dialog></ose-share-dialog>
